// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__MMrdP","pageTab":"NavBar_pageTab__MYKQB","pageTab_active":"NavBar_pageTab_active__hFkya","pageTab_inactive":"NavBar_pageTab_inactive__-ZExK"};